module.exports = __webpack_public_path__ + "static/img/2018-01-29.8493662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2018-01-29.png
// module id = xCMF
// module chunks = 1